const {
  REACT_APP_ADMIN_URL,
  REACT_APP_API_URL,
  REACT_APP_STORAGE_KEY,
  REACT_APP_STORAGE_FREQUENCY,
  REACT_APP_GTM_AUTH,
  REACT_APP_GTM_ENV
} = process.env;

export default {
  adminURL: REACT_APP_ADMIN_URL,
  api: {
    baseURL: REACT_APP_API_URL
  },
  storage: {
    key: REACT_APP_STORAGE_KEY,
    frequency: REACT_APP_STORAGE_FREQUENCY
  },
  gtm: {
    auth: REACT_APP_GTM_AUTH,
    env: REACT_APP_GTM_ENV
  }
}



// WEBPACK FOOTER //
// ./src/config.js